import { render, staticRenderFns } from "./AssetsUniformsDetails.vue?vue&type=template&id=29592b3e&"
import script from "./AssetsUniformsDetails.vue?vue&type=script&lang=js&"
export * from "./AssetsUniformsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports